import React from "react";
import Banner from "../components/Banner";
import BackButton from "../components/BackButton";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ReactComponent as DotsIcon } from "../inlineSvgs/dots.svg";
import { ReactComponent as IlusIcon } from "../inlineSvgs/ilus-phone.svg";
import { resendSms, verifyPhone } from "../api";
import { GOOGLE_AUTH } from "../config";

const VerifyPhonePage = () => {
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setFocus,
    formState: { errors },
  } = useForm({
    defaultValues: {
      one: "",
      two: "",
      three: "",
      four: "",
      five: "",
      six: "",
    },
  });
  const redirect = useNavigate();

  const phone = localStorage.getItem("registerUserPhone");
  const phoneGoogle = localStorage.getItem("GOOGLE_AUTH_Phone");

  const sendAgain = async (data) => resendSms(data);

  const sendVerifyCode = async (data) => {
    const keys = Object.keys(data);
    const code = keys.reduce((ccumulator, currentValue) => ccumulator + data[currentValue], "");
    await verifyPhone(code);

    if(phone) {
      redirect("/verify-email");
    }

    if(phoneGoogle) {
      window.location.replace(GOOGLE_AUTH);
      localStorage.removeItem("GOOGLE_AUTH_Phone");
    }
  };

  const one = watch("one");
  const two = watch("two");
  const three = watch("three");
  const four = watch("four");
  const five = watch("five");
  const six = watch("six");

  const focusInput = () => {
    const values = getValues();
    const keys = Object.keys(values);

    for (let i = 0; i < keys.length; i++) {
      if (!values[keys[i]]) {
        setFocus(keys[i]);
        return;
      }
    }
  };

  const onSubmit = (data) => {
    sendVerifyCode(data);
  };

  return (
    <div className="VerifyPhonePage">
      <Banner />
      <div className="verifySection">
        <div>
          <div className="title">Verify your account</div>
          <div className="sub-title">Secure Your Account with Phone Verification.</div>
          <DotsIcon className="step-two" />
        </div>

        <div>
          <IlusIcon />
          <div className="description">
            A code was sent to the phone number you specified during registration. If the code does not come, go back
            and check the correctness of the entered phone number.
          </div>
        </div>

        <form className="codeForm" id="code" onSubmit={handleSubmit(onSubmit)} onChange={focusInput}>
          <input
            maxLength="1"
            className={errors.one && "error"}
            type="text"
            {...register("one", { required: { value: true } })}
            autoComplete="off"
          />
          <input
            maxLength="1"
            className={errors.two && "error"}
            type="text"
            {...register("two", { required: { value: true } })}
            autoComplete="off"
          />
          <input
            maxLength="1"
            className={errors.three && "error"}
            type="text"
            {...register("three", { required: { value: true } })}
            autoComplete="off"
          />
          <input
            maxLength="1"
            className={errors.four && "error"}
            type="text"
            {...register("four", { required: { value: true } })}
            autoComplete="off"
          />
          <input
            maxLength="1"
            className={errors.five && "error"}
            type="text"
            {...register("five", { required: { value: true } })}
            autoComplete="off"
          />
          <input
            maxLength="1"
            className={errors.six && "error"}
            type="text"
            {...register("six", { required: { value: true } })}
            autoComplete="off"
          />
        </form>

        <button onClick={() => sendAgain(phoneGoogle ? phoneGoogle : phone)} className="send-again">
          Send code again
        </button>

        <div>
          <button form="code" type="submit" className="beauty-btn fill" disabled={!(one && two && three && four && five && six)}>
            Verify Phone Number
          </button>
          <BackButton className="beauty-btn border">Go Back</BackButton>
        </div>
      </div>
    </div>
  );
};

export default VerifyPhonePage;
